import { handleActions } from 'redux-actions'
import { SET_COUPON_DATA, SET_COUPON_STATE } from '../constants/couponConstant'
import { handleStateChange } from '../utils'

let initState = {
  loading: false,
  errorMessage: '',
  data: [],
  commonCoupon: [],
  deliveryCoupon: [],
  mallCoupon: []
  // deliverySelected: {}
}

export let couponData = handleActions({
  [SET_COUPON_STATE]: handleStateChange,
  [SET_COUPON_DATA]: (state, action) => {
    let deliveryCoupon = []
    let mallCoupon = []
    let commonCoupon = []
    action.payload.forEach(item => {
      let { faceValue, couponId, ...coupon } = item
      Object.assign(coupon, {
        couponId,
        label: `${faceValue} 元`,
        value: couponId,
        price: Number(faceValue)
      })
      if (item['sceneType'] === '2') {
        // 提货券
        deliveryCoupon.push(coupon)
      } else if (item['sceneType'] === '3') {
        // 零售券
        if (item['productIds'].length > 0) {
          mallCoupon.push(coupon)
        } else {
          commonCoupon.push(coupon)
        }
      }
    })
    return {
      ...state,
      data: action.payload,
      deliveryCoupon,
      mallCoupon,
      commonCoupon
    }
  }
}, initState)